import type { Branded } from '@client/new/helpers/types';
import { AuthorId, Reaction } from './post.types';

export type ReplyId = Branded<string, 'ReplyId'>;

export type Reply = {
  id: ReplyId;
  parentId: string | null;
  author: {
    id: AuthorId;
    name: string;
    avatarUrl: string;
    email: string | null;
    marketing: boolean | null;
    isOwn: boolean;
    isCreator: boolean;
    canReceiveDm: boolean;
  };
  createdAt: Date;
  content: string;
  reactions: Reaction[];
  isSensitive: boolean;
};

export const toReplyId = (value: string): ReplyId => value as ReplyId;
